import React, { Component } from 'react';
import cn from 'classnames'; // to use global class name eg. classes from grid.css in public folder
import PropTypes from 'prop-types';
import { is } from 'immutable';
import renderIf from 'render-if';
// import Input from 'react-toolbox/lib/input';// to use input from react-toolbox library
// import Button from 'components/CustomButton';
import SearchCollegeComponent from 'components/CoachRegistration';
import UserInfo from '../../../Userinfo/index';
import styles from './styles.scss';
import Error from '../../../../../../components/ErrorMessage/Error';

// to import local scss fle

class DeleteCoach extends Component {
  static propTypes = {
    resetValues: PropTypes.func.isRequired,
    getCoachesFromColleges: PropTypes.func.isRequired,
    coachesFromCollege: PropTypes.shape.isRequired, // eslint-disable-line
    deleteCoach: PropTypes.func.isRequired,
  };
  constructor(props) {
    super(props);
    this.state = {
      coachData: [],
      showNoCoaches: false,
    };
  }

  componentWillReceiveProps(np) {
    const updated = {};
    if (!is(np.coachesFromCollege, this.props.coachesFromCollege)) {
      const results = np.coachesFromCollege.toJS();
      const coachdata = [];
      results.forEach((coaches) => {
        const obj = {};
        obj.name = coaches.name;
        obj.email = coaches.coach_email;
        obj.coach_id = coaches.coach_id;
        coachdata.push(obj);
      });
      if (np.coachesFromCollege.size === 0) {
        updated.showNoCoaches = true;
      }
      updated.coachData = coachdata;
      this.setState(updated);
    }
  }

  getDataForCoach = (value) => {
    this.props.getCoachesFromColleges(value.id);
  };

  deleteCoach = (itemId, coachId) => {
    const payload = {
      coach_id: coachId,
    };
    this.props.deleteCoach(payload);
    const coaches = this.state.coachData;
    if (itemId > -1) {
      coaches.splice(itemId, 1);
    }
    this.setState({ coachData: coaches });
  };

  deleteAnotherCoach = () => {
    this.props.resetValues('RESET_DELETED_COACHES');
  };

  render() {
    const { coachData, showNoCoaches } = this.state;
    const renderCoachList = renderIf(coachData.length);
    const renderMessage = renderIf(coachData.length === 0 && showNoCoaches);
    return (
      <div className={cn('col s12', styles.removePadding)}>
        <div className={cn('col s12 m7', styles.removePadding)}>
          <span className={styles.selectCollege} >SELECT COLLEGE</span>
          <SearchCollegeComponent usedFor="contact" getDataForCoach={this.getDataForCoach} />
        </div>
        {renderCoachList(
          <div className={cn('col s12', styles.removePadding)}>
            {coachData.map((item, id) => (
              <UserInfo
                userInfo={item}
                usedFor="DELETE COACH"
                deleteCoach={this.deleteCoach}
                id={id}
              />
            ))}
          </div>,
        )}
        <div className={cn('col s12', styles.removePadding)}>
          {renderMessage(
            <Error message="No coaches found in this college." />,
        )}
        </div>
      </div>
    );
  }
}

export default DeleteCoach;



// WEBPACK FOOTER //
// ./src/containers/Admin/components/CollegeView/components/DeleteCoach/View.js